export default __webpack_public_path__ + "static/media/diagonal2@3x.63f3d20a.png";